/* eslint-disable camelcase */
import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import serviceLocator from 'live/services/service-locator'
import LiveAPI from 'live/lib/api'
import { hasPermission } from './utils/permissions'

import { en_us, pt_br } from './i18n'
import { EnvPropertiesWrapper } from './EnvProperties/EnvPropertiesWrapper'
import { ENV_PROPERTIES } from './utils/constants'

const localeFiles = { pt_br, en_us }

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}

hasPermission && serviceLocator.getService('live-ui:configuration-service').then(() => {
    LiveAPI.Extension.configuration.entries.register({
        group: i18n('Environment properties'),
        area: ENV_PROPERTIES,
        component: EnvPropertiesWrapper,
        name: i18n('Environment properties settings')
    })
})
